import { pGetAll as getAllpays } from '@/api/pays';

export default async function getAllPays(paysName) {
  const paysAutocomplete = [];
  if (!paysName.length) {
    return paysAutocomplete;
  }
  return (await getAllpays({
    query: {
      auto: paysName,
    },
    ascending: true,
  })).data.result.items
    .filter(pays => pays.actif)
    .map(item => {
      return item.nom;
    });
}
